// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ds-0";
export var headerCellHover = "_ds-1";
export var readCellContainer = "_ds-2";
export var unreadIndicator = "_ds-3";